<template>
    <div v-wechat-title="this.title">
        <van-sticky :offset-top="0">
            <div class="page_top">
                <div class="date_choose">
                    <i class="icon iconfont iconarrow-left-filling" @click="subtractDate"></i>
                    <span class="date_info" @click="chooseCheckDay">{{date || '请选择'}}</span>
                    <i class="icon iconfont iconarrow-right-filling" @click="addDate"></i>
                </div>
                <van-search class="search_div" input-align="center" background="#F8F7FC" @search="reLoad" v-model="keyword" placeholder="患者姓名或手机号" />
            </div>
        </van-sticky>


        <van-calendar v-model="showCalendar" :default-date="defaultDate" :min-date="minDate" :show-confirm="false" @confirm="onConfirmCalendar" />

        <van-dialog
                v-model:show="showBedPopup"
                :show-confirm-button="false"
                :close-on-click-overlay="true"
                class="bed-dialog">
            <template #title>
                <div class="dialog-title">
                    <span>安排床位</span>
                    <span class="close-icon" @click="showBedPopup = false">✕</span>
                </div>
            </template>
            <div class="bed-popup">
                <div class="patient-info-section" v-if="currentPatient" style="display: flex;align-items: center;justify-content: space-between;">
                    <div class="patient-header">{{currentPatient.name}}</div>
                    <div class="patient-detail">{{currentPatient.sex}} {{currentPatient.age}}</div>
                </div>
                <div class="bed-section">
                    <div class="bed-list">
                        <div
                                v-for="bed in bedList"
                                :key="bed.room_id"
                                class="bed-item"
                                :class="{
                                    'bed-occupied': bed.use_count > 0  && (bed.user_id != currentPatient.userid || bed.customer_id != currentPatient.customerid),
                                    'bed-available': bed.use_count <= 0 || (bed.use_count > 0 && bed.user_id == currentPatient.userid && bed.customer_id == currentPatient.customerid),
                                    'bed-selected': selectedBed?.room_id == bed.room_id
                                }"
                                @click="selectBed(bed)">
                          <div v-if="bed.room_id != -1" style="text-align: center">
                            <div>{{ bed.room_name }}</div>
                          </div>
                          <div v-else class="freeRoom">
                            <span>{{ bed.room_name }}</span>
                          </div>
                        </div>
                    </div>
                </div>
                <div class="confirm-section">
                    <div class="confirm-btn" @click="confirmAssignBed">确认安排</div>
                </div>
            </div>
        </van-dialog>

        <van-tabs
                v-model="qrystatus" :offset-top="62"
                @change="changeTab" class="status_div"
                color="#E69F12"
                title-active-color="#E69F12"
                sticky
                swipeable>

            <van-tab title="待分诊" name="5" :badge="waitTriage" >
              <van-pull-refresh v-model="refreshing5" @refresh="onRefresh('5')">
                <div class="treat_main_list" :class="{'bai': count5 <= 0}" >

                    <div
                        class="has_no_data"
                        v-if="!loading5 && finished5 && list5.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                            v-else
                            v-model="loading5"
                            :finished="finished5"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing5">
                          <div></div>
                        </template>

                        <div class="one"  v-for="item in list5" :key="item.serviceid">
                            <div class="name_appointment">
                                <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                                <div class="right">
                                  <div class="detail_info" style="width:auto">
                                    <div style="text-align: right;">
                                      <div>{{item.sex}} {{item.age}}</div>
                                      <div>{{item.phone}}</div>
                                    </div>
                                  </div>
                                </div>
                            </div>
                            <div class="sex_age_phone" style="padding-bottom: 0; ">
                            </div>
                            <div class="title_top">
                                <div class="left" style="font-weight:bold;font-size:0.4rem" v-if="item.projectname">
                                    <span v-for="(project, index) in item.projectname.split(',')" :key="index">
                                        <span v-if="index > 0"><br></span>
                                        {{ project }}
                                    </span>
                                </div>
                                <div v-else class="left" style="font-weight:bold;font-size:0.4rem">
                                      理疗预约
                                </div>
                                <div class="right" style="color:#999">
                                    <div><span style="margin-right:10px" >{{item.appointmentnum}}</span><span v-if="item.projectname">转理疗</span></div>
                                    <div>{{item.appointmenttime}}</div>
                                </div>
                            </div>
                            <div style="display: flex;justify-content: flex-end;">
                                <div @click="cancelProject(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">取消执行</div>

                                <div @click="goAssignTreat(item,'1')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">分诊</div>

                                <div @click="openBedPopup(item)" v-if="item.projectname"
                                    style="background-color: #CF8C57;text-align: center;color: #fff;border-radius: 10px;font-size:0.36rem;padding:8px 15px">
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                </div>
                            </div>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab title="待执行" name="2" :badge="wait" >
              <van-pull-refresh v-model="refreshing2" @refresh="onRefresh('2')">
                <div class="treat_main_list" :class="{'bai': count2 <= 0}" >
                  <div
                      class="has_no_data"
                      v-if="!loading2 && finished2 && list2.length === 0">
                    当天无理疗数据
                  </div>

                    <van-list
                            v-else
                            v-model="loading2"
                            :finished="finished2"
                            @load="onLoad"
                            :offset="30"
                            :immediate-check="false"
                            finished-text="加载完成">
                        <template #loading v-if="refreshing2">
                          <div></div>
                        </template>
                        <div class="one"  v-for="item in list2" :key="item.serviceid">
                            <div class="name_appointment">
                                <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                                <span @click="openBedPopup(item)"
                                      style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                  {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                </span>
                                <div class="right">
                                  <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                                    <div style="text-align: right;">
                                      <div>{{item.sex}} {{item.age}}</div>
                                      <div>{{item.phone}}</div>
                                    </div>
                                    <i class="icon iconfont iconsanjiaoyou"></i>
                                  </div>
                                </div>
                            </div>
                            <div class="sex_age_phone" style="padding-bottom: 0; ">
                            </div>
                            <div class="title_top">
                                <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                                <div class="right" style="color:#999">
                                  <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                                  <div>{{item.appointmenttime}}</div>
                                </div>
                            </div>
                            <div
                                class="title_top"
                                v-for="(doctor, index) in item.doctorlist"
                                :key="index"
                            >
                              <div class="left doctor-left">
                                <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                                {{ doctor.dispname }}
                                <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                  ({{ doctor.pointlist.join(',') }})
                                </span>
                              </div>
                              <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                                <div class="time">
                                  {{ formatTime(doctor, item) }}
                                </div>
                                <div class="status-text">
                                  {{ formatStatus(doctor) }}
                                </div>
                              </div>
                            </div>

                            <div style="display: flex;justify-content: flex-end;">
                              <div @click="goAssignTreat(item,'2')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                              <div v-if="!item.signaturetime" @click="searchList(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">去签名</div>

                              <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                            </div>
                        </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="执行中" name="3" :badge="execute">
              <van-pull-refresh v-model="refreshing3" @refresh="onRefresh('3')">
                <div class="treat_main_list" :class="{'bai': count3 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading3 && finished3 && list3.length === 0">
                      当天无理疗数据
                    </div>

                    <van-list
                        v-else
                        v-model="loading3"
                        :finished="finished3"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing3">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list3" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <span @click="openBedPopup(item)"
                                style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                    {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                  </span>
                          <div class="right">
                            <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                              <div style="text-align: right;">
                                <div>{{item.sex}} {{item.age}}</div>
                                <div>{{item.phone}}</div>
                              </div>
                              <i class="icon iconfont iconsanjiaoyou"></i>
                            </div>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top">
                          <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                          <div class="right" style="color:#999">
                            <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                            <div>{{item.appointmenttime}}</div>
                          </div>
                        </div>
                        <div
                            class="title_top"
                            v-for="(doctor, index) in item.doctorlist"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                    ({{ doctor.pointlist.join(',') }})
                                  </span>
                          </div>
                          <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="restartExec(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 10px">重新开始</div>
                          <div @click="goAssignTreat(item,'2')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                          <div v-if="!item.signaturetime" @click="searchList(item)" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 10px">去签名</div>

                          <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>

            <van-tab  title="已完成" name="4" :badge="finish" >
              <van-pull-refresh v-model="refreshing4" @refresh="onRefresh('4')">
                <div class="treat_main_list" :class="{'bai': count4 <= 0}">
                    <div
                        class="has_no_data"
                        v-if="!loading4 && finished4 && list4.length === 0">
                      当天无理疗数据
                    </div>
                    <van-list
                        v-else
                        v-model="loading4"
                        :finished="finished4"
                        @load="onLoad"
                        :offset="30"
                        :immediate-check="false"
                        finished-text="加载完成">
                      <template #loading v-if="refreshing4">
                        <div></div>
                      </template>
                      <div class="one"  v-for="item in list4" :key="item.serviceid">
                        <div class="name_appointment">
                          <div class="left" style="width:auto"><label v-if="item.rankicon">{{ item.rankicon }}</label>{{item.name}}</div>
                          <span style="text-align: center;color: #CF8C57;font-size:0.36rem;">
                                      {{ item.roomid ? '床位：'+item.roomname : '安排床位' }}
                                    </span>
                          <div class="right">
                            <div class="detail_info" style="width:auto" @click="detailCtrl(item.serviceid)">
                              <div style="text-align: right;">
                                <div>{{item.sex}} {{item.age}}</div>
                                <div>{{item.phone}}</div>
                              </div>
                              <i class="icon iconfont iconsanjiaoyou"></i>
                            </div>
                          </div>
                        </div>
                        <div class="sex_age_phone" style="padding-bottom: 0; ">
                        </div>
                        <div class="title_top">
                          <div class="left" style="font-weight:bold;font-size:0.4rem">{{item.projectname}}</div>
                          <div class="right" style="color:#999">
                            <div><span style="margin-right:10px">{{item.appointmentnum}}</span><span>{{item.apptype}}</span></div>
                            <div>{{item.appointmenttime}}</div>
                          </div>
                        </div>
                        <div
                            class="title_top"
                            v-for="(doctor, index) in item.doctorlist"
                            :key="index"
                        >
                          <div class="left doctor-left">
                            <span v-if="doctor.ismain == 1" class="main-tag">主</span>
                            {{ doctor.dispname }}
                            <span class="point-text" v-if="doctor.pointlist && doctor.pointlist.length">
                                      ({{ doctor.pointlist.join(',') }})
                                    </span>
                          </div>
                          <div class="right doctor-right" :class="getStatusClass(doctor)" @click="handleDoctorClick(doctor, item)">
                            <div class="time">
                              {{ formatTime(doctor, item) }}
                            </div>
                            <div class="status-text">
                              {{ formatStatus(doctor) }}
                            </div>
                          </div>
                        </div>

                        <div style="display: flex;justify-content: flex-end;">
                          <div @click="goAssignTreat(item,'2')" style="text-align: center;color: #323333 ;border-radius: 10px;font-size:0.36rem;padding:8px 15px">加项目</div>

                          <van-button type="primary" color="#CF8C57" class="r-btn" size="small" @click="openAcupointDialog(item)">配穴分工</van-button>
                        </div>
                      </div>
                    </van-list>

                </div>
              </van-pull-refresh>
            </van-tab>
        </van-tabs>

        <div class="btnimg" @click="$router.push({path:'/triage'})">
            <img src="@/assets/btn.png" alt="">
        </div>

        <acupoint-allocation
            :visible.sync="showAcupointDialog"
            :qryType="2"
            :uname="uname"
            :usex="usex"
            :uage="uage"
            :uphone="uphone"
            :userId="Number(currentUserId)"
            :customerId="Number(currentCustomerId)"
            :tCode="currenttCode"
            :serviceId="currentServiceId"
            :qrydate="date"
            :currentallpoints="currentAllPoints"
            :currentAcupointData="currentAcupointData"
            @save="handleAcupointSave"
        />
    </div>
</template>

<script>
import axios from 'axios'
import {
  wxtreatstatistics,
  wxtreatqry,
  wxqryfreeroom,
  wxsaveroom,
  wxoprtreat,
  waitsignaturelist,
  wxtreatopr,wxrestarttreat
} from '@/api/medical'
    import { mapGetters } from 'vuex'
    // import Vue from 'vue';
    import { Toast,Dialog } from 'vant';
    import Vue from 'vue';
    import { Calendar } from 'vant';
    import AcupointAllocation from "@/view/acupointAllocation/index.vue";
    import { getServerNow } from '@/utils/time'

    Vue.use(Calendar);

    const DEFAULT_QRY_STATUS = '5'
    const QRY_STATUS_CONFIG = {
      '5': {
        loading: 'loading5',
        finished: 'finished5',
        count: 'count5',
        page: 'page5',
        list: 'list5',
        isload: 'isload5',
        refreshing: 'refreshing5'
      },
      '2': {
        loading: 'loading2',
        finished: 'finished2',
        count: 'count2',
        page: 'page2',
        list: 'list2',
        isload: 'isload2',
        refreshing: 'refreshing2'
      },
      '3': {
        loading: 'loading3',
        finished: 'finished3',
        count: 'count3',
        page: 'page3',
        list: 'list3',
        isload: 'isload3',
        refreshing: 'refreshing3'
      },
      '4': {
        loading: 'loading4',
        finished: 'finished4',
        count: 'count4',
        page: 'page4',
        list: 'list4',
        isload: 'isload4',
        refreshing: 'refreshing4'
      }
    }

    export default {
      components: {AcupointAllocation},
        computed: {
            ...mapGetters([
                'username','clinicid','isrefresh','isclose','clinicname'
            ]),
        },
        data() {
            return {
                qrystatus: DEFAULT_QRY_STATUS,
                oldQrystatus: DEFAULT_QRY_STATUS,
                list5: [],
                loading5: false,
                finished5: false,
                count5: 0,
                page5: 1,
                isload5: false,
                refreshing5: false,

                list2: [],
                // 无限加载
                loading2: false,
                finished2: false,
                count2: 0,
                page2: 1,
                isload2: false,
                refreshing2: false,

                list3: [],
                // 无限加载
                loading3: false,
                finished3: false,
                count3: 0,
                page3: 1,
                isload3: false,
                refreshing3: false,

                list4: [],
                // 无限加载
                loading4: false,
                finished4: false,
                count4: 0,
                page4: 1,
                isload4: false,
                refreshing4: false,
                keyword: '',
                waitTriage: 0,
                wait: 0,
                execute: 0,
                finish:0,
                minDate: new Date(2020, 0, 1),
                defaultDate: new Date(),
                date:'',
                showCalendar:false,
                title:'理疗工作台',
                loading: false,
                loadingStatus: '',
                loadRequestNo: 0,
                loadCancelSource: null,
                showBedPopup: false,
                bedList: [],
                selectedBed: null,
                currentPatient: null,

                showAcupointDialog:false,
                uname:null,
                usex:null,
                uphone:null,
                uage:null,
                currentAllPoints:null,
                currentAcupointData:[],
                currentItemRef: null,
                currentServiceId: null,
                currentUserId: null,
                currentCustomerId: null,
                currenttCode: null,

                timer: null,
                signaturelist:[]
            }
        },
        mounted () {
            this.$store.dispatch('changeIsClose', '1')
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            this.getCurDate()

            this.restoreTreatPageTab()


            this.startTimer()
            this.setListLoading(this.qrystatus, true)
            this.onLoad()
        },
        beforeDestroy() {
          this.stopTimer()
          // 离开页面时取消待返回的列表请求，避免缓存页销毁后继续回写状态。
          this.cancelLoadRequest()
          this.loadRequestNo = this.loadRequestNo + 1
        },
        activated() {
            this.startTimer()
            this.$store.dispatch('changeNav', '0')
            this.$store.dispatch('hideOrShowNav', false)
            this.restoreTreatPageTab()
            console.log(this.isrefresh, '----isrefresh')
            if(this.isrefresh == '1' && !this.loading) {
                this.$store.dispatch('changeIsRefresh', '0')
                // this.reLoad();
                this.onRefresh(this.qrystatus)
            }
        },
        deactivated() {
          this.stopTimer()
        },
        beforeRouteLeave(to, from, next) {
            console.log(to,from,'treat-----')
            if(to.path == '/assignTreat'){
                from.meta.keepAlive = false

            }else if(to.path == '/triage'){
                to.meta.keepAlive = false
            }
            next()
        },
        methods: {
            goBack() {
                window.WeixinJSBridge.call('closeWindow')
            },
            getCurDate() {
                const nowDate = new Date();
                this.formatDate(nowDate)
            },
            addDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() + 1);
                this.formatDate(d)
                this.reLoad()
            },
            subtractDate() {
                var d = new Date(this.date);
                d.setDate(d.getDate() - 1);
                this.formatDate(d)
                this.reLoad()
            },
            formatDate(d) {
                const curDate = {
                    year: d.getFullYear(),
                    month: d.getMonth() + 1,
                    date: d.getDate(),
                }
                const newmonth = curDate.month>=10?curDate.month:'0'+curDate.month
                const day = curDate.date>=10?curDate.date:'0'+curDate.date
                this.date = curDate.year + '-' + newmonth + '-' + day
                this.defaultDate = new Date(this.date);
            },
            chooseCheckDay(){
                this.showCalendar = true
            },
            onConfirmCalendar(date){
                this.showCalendar = false
                this.formatDate(date);

                this.reLoad()
            },

            changeTab(name){
              const status = this.getValidQryStatus(name)
              if (this.loading && this.loadingStatus === status) {
                Toast('数据加载中，请稍后再切换')

                this.$nextTick(() => {
                  this.qrystatus = this.oldQrystatus
                })

                return
              }

              this.oldQrystatus = status
              this.qrystatus = status

              this.resetCurrentTab(status)

              this.setListLoading(status, true)
              this.onLoad()
            },
            setListLoading(status, value) {
              const config = this.getTabConfig(status)
              this[config.loading] = value
            },
            /**
             * 获取页面支持的查询状态，非法状态统一回到待分诊。
             */
            getValidQryStatus(status) {
              const validStatus = status + ''
              return QRY_STATUS_CONFIG[validStatus] ? validStatus : DEFAULT_QRY_STATUS
            },
            /**
             * 获取指定状态对应的列表字段配置。
             */
            getTabConfig(status) {
              return QRY_STATUS_CONFIG[this.getValidQryStatus(status)]
            },
            /**
             * 判断指定状态的列表是否已经加载完成。
             */
            isTabFinished(status) {
              const config = this.getTabConfig(status)
              return this[config.finished]
            },
            /**
             * 获取指定状态当前要查询的页码。
             */
            getTabPage(status) {
              const config = this.getTabConfig(status)
              return this[config.page]
            },
            /**
             * 解析接口返回的数量字段，避免空值变成 NaN。
             */
            parseCount(value) {
              const count = parseInt(value || 0)
              return isNaN(count) ? 0 : count
            },
            /**
             * 取消当前未完成的列表请求。
             */
            cancelLoadRequest() {
              if (this.loadCancelSource) {
                this.loadCancelSource.cancel('cancel treatPage pending request')
                this.loadCancelSource = null
              }
            },
            /**
             * 创建本次列表加载上下文，并在新请求开始前取消旧请求。
             */
            createLoadContext(status) {
              this.cancelLoadRequest()
              this.loadRequestNo = this.loadRequestNo + 1

              const source = axios.CancelToken.source()
              this.loadCancelSource = source

              return {
                requestNo: this.loadRequestNo,
                status: status,
                cancelToken: source.token
              }
            },
            /**
             * 判断接口回调是否仍属于当前页面的最新请求。
             */
            isCurrentLoadContext(loadContext) {
              return loadContext
                  && loadContext.requestNo === this.loadRequestNo
                  && loadContext.status === this.qrystatus
            },
            /**
             * 结束当前列表加载状态。
             */
            finishLoadContext(loadContext) {
              if (!this.isCurrentLoadContext(loadContext)) {
                return
              }

              this.setListLoading(loadContext.status, false)
              this.setRefreshing(loadContext.status, false)
              this.loading = false
              this.loadingStatus = ''
              this.loadCancelSource = null
            },
            /**
             * 按统计数量变化重置已经加载过的页签。
             */
            resetLoadedTabWhenCountChanged(status, newCount, oldCount) {
              const config = this.getTabConfig(status)
              if (this[config.isload] && newCount !== oldCount) {
                // 统计数量变化时重置对应页签，避免继续展示旧分页数据。
                this.resetCurrentTab(status)
              }
            },
            /**
             * 处理理疗工作台统计接口返回值。
             */
            handleStatisticsResponse(response) {
              if (!response.response_body) {
                return
              }

              const oldWaitTriage = this.waitTriage
              const oldWait = this.wait
              const oldExecute = this.execute
              const oldFinish = this.finish

              this.waitTriage = this.parseCount(response.response_body.waitTriage)
              this.wait = this.parseCount(response.response_body.wait)
              this.execute = this.parseCount(response.response_body.execute)
              this.finish = this.parseCount(response.response_body.finish)

              this.resetLoadedTabWhenCountChanged('5', this.waitTriage, oldWaitTriage)
              this.resetLoadedTabWhenCountChanged('2', this.wait, oldWait)
              this.resetLoadedTabWhenCountChanged('3', this.execute, oldExecute)
              this.resetLoadedTabWhenCountChanged('4', this.finish, oldFinish)
            },
            /**
             * 处理理疗工作台列表接口返回值。
             */
            handleTreatQryResponse(status, response) {
              const config = this.getTabConfig(status)
              this[config.isload] = true

              if (response.response_body && response.response_body.list) {
                const pages = this.parseCount(response.response_body.pages)
                this[config.count] = this.parseCount(response.response_body.num)
                this[config.list] = this[config.list].concat(response.response_body.list)
                this[config.finished] = pages <= 0 || this[config.page] >= pages
                this[config.page] = this.parseCount(this[config.page]) + 1
                return
              }

              // 没有列表数据时也要结束加载，避免 van-list 继续触发 load。
              this[config.finished] = true
            },
            reLoad(){
                // Manual reload should replace pending work for the current query condition.
                this.cancelLoadRequest()
                this.loading = false
                this.loadingStatus = ''

                Object.keys(QRY_STATUS_CONFIG).forEach(status => {
                  // 日期或关键字变化时重置所有页签，避免不同查询条件的数据混在一起。
                  this.resetCurrentTab(status)
                })
                this.onLoad()
            },
            onLoad(){
                const status = this.getValidQryStatus(this.qrystatus)
                if (this.qrystatus !== status) {
                  this.qrystatus = status
                  this.oldQrystatus = status
                }

                console.log(this.clinicid, '*****this.clinicid')
                if(this.clinicid == null || this.clinicid == '' || this.clinicid == undefined
                    || this.username == null || this.username == '' || this.username == undefined) {
                    Toast.loading({
                        duration: 0, // 持续展示 toast
                        forbidClick: true,
                        message: '未登录或未选择诊所，页面关闭',
                    });
                    let second = 1;
                    const timer = setInterval(() => {
                        second--;
                        if (!second) {
                            clearInterval(timer);
                            // 手动清除 Toast
                            Toast.clear();
                            this.goBack()
                        }
                    }, 1000);
                    // Login/clinic guard exits before requests, so release current list state.
                    this.setListLoading(status, false)
                    this.setRefreshing(status, false)
                    return;

                }
                if(this.isTabFinished(status)) {
                    this.setListLoading(status, false)
                    this.setRefreshing(status, false)
                    return
                }
                if (this.loading && this.loadingStatus === status) return

                this.loading = true
                this.loadingStatus = status
                this.setListLoading(status, true)
                // New load cancels pending request and marks older callbacks as stale.
                const loadContext = this.createLoadContext(status)
                const requestConfig = {
                    cancelToken: loadContext.cancelToken
                }

                let sdata = {
                    username: this.username,
                    qrydate: this.date,
                    keyword: this.keyword,
                    clinicid: this.clinicid
                }
                wxtreatstatistics(sdata, requestConfig).then(response => {
                    if (!this.isCurrentLoadContext(loadContext)) {
                        return
                    }

                    // Update badge counts before querying the current tab list.
                    this.handleStatisticsResponse(response)

                    let qryPage = this.getTabPage(status);
                    let data = {
                        username: this.username,
                        qrydate: this.date,
                        keyword: this.keyword,
                        page: qryPage + '',
                        qrystatus: status,
                        clinicid: this.clinicid
                    }
                    return wxtreatqry(data, requestConfig).then(response => {
                        if (!this.isCurrentLoadContext(loadContext)) {
                            return
                        }

                        if(Toast){
                            Toast.clear()
                        }

                        // Write list data only to the tab captured when this request started.
                        this.handleTreatQryResponse(status, response)
                    })
                }).catch(error => {
                    if (axios.isCancel(error) || !this.isCurrentLoadContext(loadContext)) {
                        return
                    }
                }).then(() => {
                    // Always release the newest active request; stale requests are ignored.
                    this.finishLoadContext(loadContext)
                })


            },

            // 理疗详情
            detailCtrl(serviceid){
                this.$store.dispatch('changeIsRefresh', '0')
                this.$router.push({
                    path: '/treatDetail',
                    query: {
                        serviceid: serviceid,
                        qrydate: this.date
                    }
                })
            },
            openBedPopup(item) {
                this.currentPatient = item
                this.selectedBed = null
                this.bedList = []
                this.showBedPopup = true
                wxqryfreeroom({ clinicid: this.clinicid }).then(response => {
                    if (response.response_body && response.response_body.list) {
                        this.bedList = response.response_body.list
                        // 增加“无需床位”选项
                        this.bedList.push({
                          room_id: -1,
                          room_name: '无需床位',
                          use_count: 0
                        })

                        let defaultBed = null
                        if (item.roomid) {
                          defaultBed = this.bedList.find(
                              bed => bed.room_id == item.roomid
                          )
                        }

                        // 如果没有当前床位，则默认选中第一个空闲床位
                        if (!defaultBed) {
                          defaultBed = this.bedList.find(
                              bed => bed.use_count <= 0
                          )
                        }

                        // 设置默认选中
                        if (defaultBed) {
                          this.selectedBed = defaultBed
                        }
                    }
                })
            },
            selectBed(bed) {
                // 无需床位允许选中
                if (bed.room_id != -1 && bed.use_count > 0 && (bed.user_id != this.currentPatient.userid || bed.customer_id != this.currentPatient.customerid)) {
                  return
                }

                this.selectedBed = bed
            },

            confirmAssignBed() {
                if (!this.selectedBed) {
                    Toast('请先选择床位')
                    return
                }
                wxsaveroom({
                    roomId: this.selectedBed.room_id,
                    userId: this.currentPatient.userid,
                    customerId: this.currentPatient.customerid,
                    date: this.date,
                    username: this.username,
                    serviceid: this.currentPatient.allserviceid,
                    clinicid: this.clinicid
                }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('安排床位成功')
                        this.showBedPopup = false

                        // 跳转分诊
                        if (this.qrystatus == '5' && response.response_body.isjumppage){
                          this.goAssignTreat(this.currentPatient,'1')
                          return;
                        }
                        this.reLoad()
                      }else{
                        Toast.fail(response.response_body.msg)
                      }
                })
            },

            openAcupointDialog(item) {
              this.currentItemRef = item
              this.uname = item.name
              this.uphone = item.phone
              this.usex = item.sex
              this.uage = item.age
              this.currentServiceId = item.serviceid
              this.currentAllPoints = item.allpoints
              this.currentAcupointData = item.doctorlist
              this.currentUserId = item.userid
              this.currentCustomerId = item.customerid
              this.currenttCode = item.projectcode
              this.showAcupointDialog = true
            },

            // 状态文字
            formatStatus(doctor) {
              if (doctor.status == 0) return '开始治疗'
              if (doctor.status == 1) return '完成治疗'
              if (doctor.status == 2) return '已完成'
              return ''
            },

            // 时间显示
            formatTime(doctor, item) {
              if (doctor.status == 0) {
                return '--:--'
              }

              let seconds = 0

              // 已完成
              if (doctor.status == 2) {
                seconds = this.getSeconds(doctor.endtime) - this.getSeconds(doctor.starttime)
              }

              // 执行中（动态）
              if (doctor.status == 1) {
                seconds = Math.floor(getServerNow() / 1000) - this.getSeconds(doctor.starttime)
              }

              if (seconds < 0) seconds = 0

              const m = Math.floor(seconds / 60)
              const s = seconds % 60

              return `${this.pad(m)}:${this.pad(s)}`
            },

            // 时间转秒（兼容字符串）
            getSeconds(time) {
              if (!time) return 0

              const safeTime = time.replace(/-/g, '/')
              const timestamp = new Date(safeTime).getTime()
              if (isNaN(timestamp)) return 0

              return Math.floor(timestamp / 1000)
            },

            pad(num) {
              return num < 10 ? '0' + num : num
            },

            // 启动页面计时刷新，避免重复创建定时器。
            startTimer() {
              if (this.timer) {
                return
              }

              this.timer = setInterval(() => {
                // 触发视图更新（关键）
                this.$forceUpdate()
              }, 1000)
            },

            // 停止页面计时刷新，避免缓存页面在后台继续改写标题。
            stopTimer() {
              if (!this.timer) {
                return
              }

              clearInterval(this.timer)
              this.timer = null
            },

            getStatusClass(doctor) {
              if (doctor.status == 2) return 'status-finished'
              return 'status-active'
            },

            handleDoctorClick(doctor, item) {
              // 已完成不允许再点
              if (doctor.status == 2) return

              let oprtype = null
              let text = ''

              if (doctor.status == 0) {
                oprtype = 1
              }

              if (doctor.status == 1) {
                oprtype = 2
              }

              wxoprtreat({
                serviceId: item.serviceid,
                treatId: doctor.treatid,
                oprType: oprtype,
                doctor: this.username
              }).then((response) => {
                if (response.response_body.flag) {
                  Toast.success('操作成功')

                  // 更新状态
                  doctor.status = oprtype

                  // 使用接口返回时间
                  if (oprtype == 1) {
                    doctor.starttime = response.response_body.startTime

                    if (response.response_body.isStart === true) {
                      this.reLoad()
                      return
                    }
                  }

                  if (oprtype == 2) {
                    doctor.endtime = response.response_body.endTime

                    if (response.response_body.isEnd === true) {
                      Toast({
                        message: '加载中...',
                        type: 'loading',
                        duration: 0
                      })

                      this.reLoad()
                      return
                    }
                  }
                }else{
                  if (!response.response_body.issign){
                    Dialog.confirm({
                      title: '提示',
                      message: response.response_body.msg,
                      confirmButtonText: '去签名',
                      cancelButtonText: '取消'
                    })
                        .then(() => {
                          this.searchList(item)
                        })
                        .catch(() => {
                          // 点击取消，不做任何事
                        })
                  }else{
                    Toast.fail(response.response_body.msg)
                  }
                }
              })

            },

            handleAcupointSave(newList) {
              if (!this.currentItemRef) return

              // 关键：直接覆盖 doctors
              this.$set(this.currentItemRef, 'doctorlist', newList)

              //刷新页面
              this.reLoad()
            },

            //签名
            // 待签名服务查询  waitsignaturelist
            // 查询待签名列表
            searchList(item){
              console.log('item',item)
              let value = {
                username: this.username,
                serviceid: item.serviceid,
              };
              waitsignaturelist(value).then(res =>{

                const list = res && res.response_body ? res.response_body.list : []
                this.signaturelist = this.getValidSignatureList(list)

                this.changeRouter(item);
              })
            },
            // 获取待签名列表，接口未返回数组时按空列表处理，避免跳转前遍历报错
            getValidSignatureList(list) {
              return Array.isArray(list) ? list : []
            },
            /**
             * 保存当前理疗列表选中的 tab，用于从子页面返回后恢复原位置。
             */
            saveCurrentTreatTab() {
              sessionStorage.setItem('TREAT_PAGE_TAB', this.getValidQryStatus(this.qrystatus))
            },
            /**
             * 恢复跳转前保存的理疗列表 tab，读取后立即清理，避免影响后续入口。
             */
            restoreTreatPageTab() {
              const treatPageTab = sessionStorage.getItem('TREAT_PAGE_TAB')
              if (!treatPageTab) {
                return
              }

              const lastTab = this.getValidQryStatus(treatPageTab)
              this.qrystatus = lastTab
              this.oldQrystatus = lastTab
              sessionStorage.removeItem('TREAT_PAGE_TAB')
            },
            /**
             * 跳转签名页前保存当前 tab，签名完成返回后仍停留在来源 tab。
             */
            goSignature(item, isAll) {
              this.saveCurrentTreatTab()
              this.$router.push({
                path:'/signature',
                query:{
                  serviceid:item.serviceid ,
                  isAll:isAll ? 'true' : 'false',
                }
              })
            },
            changeRouter(item){
              var arr = this.getValidSignatureList(this.signaturelist)

              console.log("item",item)
              let datas = arr.filter(vo => vo.id != item.serviceid).map(vo => vo.projectname )

              if(datas.length > 0){

                Dialog.confirm({
                  title: '提示',
                  message: `患者当天还存在其他理疗项目（${datas.join('、')}）未签名，是否同步签名`,
                  confirmButtonText:'全部签名',
                  cancelButtonText:'仅签名当前项目',
                })
                    .then(() => {
                      // on confirm
                      this.goSignature(item, true)
                    })
                    .catch(() => {
                      // on cancel
                      this.goSignature(item, false)
                    });
              }else{
                this.goSignature(item, false)
              }
            },
            onRefresh(status) {
              const refreshStatus = this.getValidQryStatus(status)
              // Pull refresh replaces pending work for the same tab.
              this.cancelLoadRequest()
              this.loading = false
              this.loadingStatus = ''

              this.qrystatus = refreshStatus
              this.oldQrystatus = refreshStatus

              this.resetCurrentTab(refreshStatus)

              this.onLoad()
            },
            resetCurrentTab(status) {
              const config = this.getTabConfig(status)
              this[config.finished] = false
              this[config.loading] = false
              this[config.count] = 0
              this[config.page] = 1
              this[config.list] = []
              this[config.isload] = false
            },
            setRefreshing(status, value) {
              const config = this.getTabConfig(status)
              this[config.refreshing] = value
            },
            goAssignTreat(item,oprtype){
              this.saveCurrentTreatTab()
              this.$store.dispatch('changeIsRefresh', '1')

              this.$router.push({
                path: '/assignTreat',
                query: {
                  userid: item.userid,
                  customerid: item.customerid,
                  name: item.name || '',
                  sex: item.sex || '',
                  age: item.age || '',
                  phone: item.phone || '',
                  appointmentid: item.appointmentid || '',
                  roomid: item.roomid || '',
                  roomname: item.roomname || '',
                  qryDate: this.date,
                  oprtype: oprtype || '2', // 1:转理疗分诊，2:直接分诊
                }
              })
            },
            // 取消执行
            cancelProject(item){
              this.$dialog.confirm({
                title: null,
                message: '确认取消本次理疗？',
              })
                  .then(() => {
                    let data = {
                      username: this.username,
                      oprtype: '0',
                      serviceid: item.allserviceid
                    }
                    wxtreatopr(data).then(() => {
                      Toast.success('已成功取消本次理疗!');
                      this.onRefresh('5')
                    })
                  })
                  .catch(() => {
                    // on cancel
                  });
            },
            restartExec(item){
              // 二次确认
              Dialog.confirm({
                title: '提示',
                message: '重新开始会将项目回退到待执行状态，确认是否重新开始？',
                confirmButtonText: '确认',
                cancelButtonText: '取消'
              })
                  .then(() => {
                    // 点击确认才执行接口
                    wxrestarttreat({
                      serviceid: item.serviceid,
                      doctor: this.username
                    }).then((response) => {
                      if (response.response_body.flag) {
                        Toast.success('操作成功')
                        this.onRefresh('2')
                      }else{
                        Toast.fail(response.response_body.msg)
                      }
                    })
                  })
                  .catch(() => {
                    // 点击取消，不做任何事
                  })
          }
        },
    }
</script>

<style lang="scss" scoped>
    .van-info{
        top: 2px;
        right: -8px;
    }
    .van-cell{
        background-color: #F8F7FC;
        border-radius: 0.50667rem;
    }
    .bai {
        background-color: #ffffff;
    }
    .btnimg{
        width: 50px;
        height: 50px;
        position: fixed;
        right: 10px;
        bottom: 200px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .treat_main_list .one{
        background: linear-gradient( 180deg, rgba(207,140,87,0.2) 0%, rgba(255,249,244,0) 20%);
        padding: 16px;
        border-radius: 12px;
        margin: 12px;
    }
    .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }
    .patient-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
    .patient-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
    }
    .patient-detail {
        font-size: 14px;
        color: #666;
    }
    .card-middle {
        padding: 12px 0;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .project-name {
        font-size: 16px;
        font-weight: 500;
        color: #333;
        flex: 1;
        margin-right: 12px;
    }
    .time-location {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        font-size: 14px;
        color: #666;
    }
    .card-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 12px;
    }
    .triage-btn {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #CF8C57;
        font-size: 14px;
        cursor: pointer;
    }
    .bed-info {
        background: #CF8C57;
        color: #fff;
        padding: 8px 16px;
        border-radius: 6px;
        font-size: 14px;
    }
    .bed-dialog {
        width: 90%;
        max-width: 400px;
        border-radius: 12px;
    }
    .bed-dialog :deep(.van-dialog__header) {
        padding: 20px 20px 10px;
    }
    .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .dialog-title span:first-child {
        font-size: 18px;
        font-weight: 600;
        color: #333;
    }
    .close-icon {
        font-size: 20px;
        color: #999;
        cursor: pointer;
        line-height: 1;
    }
    .bed-dialog :deep(.van-dialog__content) {
        max-height: 70vh;
        overflow-y: auto;
    }
    .bed-popup {
        padding: 10px 0 0;
    }
    .patient-info-section {
        background: #CF8C57;
        border-radius: 12px;
        padding: 8px;
        margin: 0 20px 24px;
    }
    .patient-header {
        font-size: 20px;
        color: #fff;
    }
    .patient-detail {
        font-size: 16px;
        color: #fff;
    }
    .bed-section {
        padding: 0 20px;
    }
    .section-title {
        font-size: 20px;
        font-weight: 600;
        color: #333;
        margin-bottom: 16px;
    }
    .bed-list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
    }
    .bed-item {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        font-size: 16px;
        cursor: pointer;
        padding: 8px;
        flex-direction: column;
    }
    .bed-occupied {
        background: #ddd;
        color: #999;
        cursor: not-allowed;
    }
    .bed-available {
        background: #fff;
        border: 1px solid #CF8C57;
        color: #CF8C57;
    }
    .bed-selected {
        background: #CF8C57 !important;
        color: #fff !important;
        border: 1px solid #CF8C57;
    }
    .confirm-section {
        padding: 20px;
    }
    .confirm-btn {
        width: 100%;
        height: 50px;
        background: #CF8C57;
        color: #fff;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        font-weight: 600;
    }

    .point-text {
      color: #999;
      margin-left: 4px;
    }


    .doctor-left {
      width: 75% !important;
      word-break: break-all;
      white-space: normal !important;
      line-height: 1.4;
    }

    .doctor-right {
      width: 25% !important;
      text-align: center !important;
      border-radius: 8px;
      padding: 5px;
    }

    .main-tag {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      background: #CF8C57; /* 土黄 */
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    /* 已完成：灰底灰字 */
    .status-finished {
      background: #f2f2f2;
      color: #999;
    }

    /* 未开始 + 执行中：土黄底白字 */
    .status-active {
      background: #CF8C57;
      color: #fff;
    }

    /* 时间 */
    .time {
      font-size: 14px;
    }

    /* 状态文字 */
    .status-text {
      font-size: 12px;
      margin-top: 2px;
    }

    .freeRoom{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .freeRoom img{
      width: 30px;
    }

    .page-loading {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 9999;
      background: rgba(255, 255, 255, 0.75);
      display: flex;
      align-items: center;
      justify-content: center;
    }
</style>
